
import React from 'react';

const OrderModeTabs = ({ activeMode, onModeChange, counts }) => {
  return (
    <div className="order-mode-tabs">
      <button 
        className={`order-mode-tab ${activeMode === 'in_store' ? 'active' : ''}`}
        onClick={() => onModeChange('in_store')}
      >
        🏪 EN MAGASIN ({counts.in_store || 0})
      </button>
      <button 
        className={`order-mode-tab ${activeMode === 'takeaway' ? 'active' : ''}`}
        onClick={() => onModeChange('takeaway')}
      >
        🥡 À EMPORTER ({counts.takeaway || 0})
      </button>
      <button 
        className={`order-mode-tab ${activeMode === 'delivery' ? 'active' : ''}`}
        onClick={() => onModeChange('delivery')}
      >
        🚚 À LIVRER ({counts.delivery || 0})
      </button>
      <button 
        className={`order-mode-tab ${activeMode === 'all' ? 'active' : ''}`}
        onClick={() => onModeChange('all')}
      >
        TOUT ({counts.all || 0})
      </button>
    </div>
  );
};

export default OrderModeTabs;
